import { useState } from "react";
import type { AdminAuditLogRecord } from "../../api";
import { formatAuditAction, formatAuditTarget, formatTime } from "../../format";
import { formatAuditPayload, matchesQuery } from "./GmShared";

export function AuditLogPanel({ auditLog }: { auditLog: AdminAuditLogRecord[] }) {
  const [query, setQuery] = useState("");
  const [actionFilter, setActionFilter] = useState("all");
  const actionValues = Array.from(new Set(auditLog.map((entry) => entry.action)));
  const filteredAuditLog = auditLog.filter((entry) => {
    return (
      (actionFilter === "all" || entry.action === actionFilter) &&
      matchesQuery([entry.action, entry.targetType, entry.targetId, formatAuditAction(entry.action), formatAuditTarget(entry.targetType), formatAuditPayload(entry.payload)], query)
    );
  });

  return (
    <div className="audit-console">
      <div className="gm-filter-bar">
        <label>
          审计筛选
          <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="动作/对象/载荷" />
        </label>
        <label>
          动作
          <select value={actionFilter} onChange={(event) => setActionFilter(event.target.value)}>
            <option value="all">全部</option>
            {actionValues.map((action) => (
              <option key={action} value={action}>
                {formatAuditAction(action)}
              </option>
            ))}
          </select>
        </label>
      </div>
      <ul className="audit-list">
        {filteredAuditLog.length === 0 && <li>审计日志为空或没有匹配项。</li>}
        {filteredAuditLog.map((entry) => (
          <li key={entry.id}>
            <span>{formatTime(entry.createdAt)}</span>
            <strong>{formatAuditAction(entry.action)}</strong>
            <em>
              {formatAuditTarget(entry.targetType)}:{entry.targetId.slice(0, 8)}
            </em>
            <code>{formatAuditPayload(entry.payload)}</code>
          </li>
        ))}
      </ul>
    </div>
  );
}

